import { Link, Typography } from "@platform/design-system";

import type { ReactNode } from "react";

/**
 * An RFP's id, linked to its page in the portal when the API sent one. It opens in a
 * new tab, so the review stays where it was.
 */
export const RfpLink = ({
  id,
  url,
}: {
  readonly id: string | null | undefined;
  readonly url: string | null;
}): ReactNode => {
  if (!id) {
    return (
      <Typography variant="body-medium" color="textSecondary" component="span">
        —
      </Typography>
    );
  }
  if (!url) return id;
  return (
    <Link href={url} target="_blank" rel="noopener noreferrer">
      {id}
    </Link>
  );
};
